export enum ActiveTrack {
    VideoTrim,
    Slide,
    Chapter,
    Poll,
    Chat,
    VideoLayout
}
